
<div id="greeting" class="flex-cell" *ngIf="!userSer.isAgent()">
    <div id="hello">
        <span>Employees</span>
    </div>
    <div id="welcomeBack">
        <span>Synced from ADP</span>
    </div>
</div>

<div class="dashboard-content-sec">
    <div class="card mb-0">
        <app-breadcrumb [crumbList] = "crumbList"></app-breadcrumb>

        <div class="table-responsive">
          <div class="loader" *ngIf="showloader">
            <img src="assets/images/loader.gif" alt="">
          </div>
            <table class="table user-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Work email</th>
                        <th>Department</th>
                        <th>Worker type</th>
                        <th>Hire date</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let emp of employees">
                        <tr>
                            <td>{{emp.first_name}} {{emp.last_name}}</td>
                            <td>{{emp.work_email}}</td>
                            <td>{{emp.department}}</td>
                            <td>{{emp.worker_type}}</td>
                            <td>{{emp.hire_date ? (emp.hire_date | date) : ''}}</td>
                            <td>{{emp.employment_status}}</td>
                        </tr>
                    </ng-container>
                </tbody>

                <ng-container *ngIf="!showloader && employees?.length == 0">
                  <tr><td colspan="6">No employee records yet</td></tr>
                </ng-container>

            </table>
        </div>
    </div>
</div>
